import { create } from 'zustand'

import type { AuthenticatedUser } from '@/types/models'

/**
 * Sunucu durumu değil, **türetilmiş** bir ayna: kaynak `GET /auth/me`'nin TanStack
 * Query önbelleğidir (bkz. `useAuth`). Bu store yalnızca kimlik/izin bilgisine
 * React Query bağlamı olmayan yerlerden (rota koruması, kenar bileşenler) ucuz ve
 * eşzamanlı erişim sağlar; kendi başına veri çekmez veya önbelleklemez.
 */
interface AuthState {
  identity: AuthenticatedUser | null
  setIdentity: (identity: AuthenticatedUser | null) => void
  hasPermission: (permission: string) => boolean
}

export const useAuthStore = create<AuthState>()((set, get) => ({
  identity: null,
  setIdentity: (identity) => {
    set({ identity })
  },
  hasPermission: (permission) => {
    const { identity } = get()
    if (!identity) return false
    return identity.is_superadmin || identity.permissions.includes(permission)
  },
}))
